import { Navigate, useLocation } from "react-router-dom";
import cookie from "js-cookie";
import { useSelector } from "react-redux";
import { deepSearchMenus } from "../utils/tools";
import { message } from "antd";
import http from "../utils/http";
import { useState } from "react";
const auth = (Comp) => {


  return () => {
    // http.post('/api/v1/token/verify/',{token:localStorage.getItem('accecc_token')})
    // .then(res=>{
    //   console.log(res.token)
    //   console.log(Object.keys(res).length)
    
    // })
    // .catch(err=>{})
    const TokenVal = sessionStorage.getItem("token");
    if (!TokenVal) {
      message.error('Please Login')
      return <Navigate to="/login" />;
    }

    // const { menus } = useSelector((state) => state.userInfo);
    // const { pathname } = useLocation();
    // // console.log(deepSearchMenus(menus, pathname).length);
    // if (deepSearchMenus(menus, pathname).length <= 0) {
    //   return <Navigate to="/403" />;
    // }

    return <Comp />;
  };
};
export default auth;
